import * as React from "react";
import styled from "styled-components";
import Loading from "../../Loading";

const LoadingWrapper = styled.div`
  align-self: center;
  flex-basis: 100%;
`;

export const ChartLoader: React.FC = () => (
  <LoadingWrapper>
    <Loading />
  </LoadingWrapper>
);
